import React, { useState, useRef, useEffect } from 'react';
import { Printer, Plus, Edit2, Save, X, Trash2, FileText, Send, Loader2, Eye } from 'lucide-react';
import apiService from '../config';
import { useLanguage } from '../StoreContext/LanguageContext';
import SignaturePad from '../DigitalSignature/SignaturePad';
import { useSignature } from '../DigitalSignature/UseSignatue';

function Tehsildar() {
  const [records, setRecords] = useState([]);
  const [tempData, setTempData] = useState({});
  const [formData, setFormData] = useState({
    bhusampadan_no: '',
    village_name: '',
    taluka: '',
    district: 'बुलढाणा'
  });
  const [recordTypeOptions, setRecordTypeOptions] = useState([]);
  const [projectId, setProjectId] = useState(null);
  const [proposalId, setProposalId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loadingRecords, setLoadingRecords] = useState(false);
  const [workSummary, setWorkSummary] = useState([]);
  const [reportData, setReportData] = useState([]);
  const { language, translations } = useLanguage();
   const [selectedDocumentLAO, setselectedDocumentLAO] = useState(null);
    const [remarksLAO, setremarksLAO] = useState('Approved');
    const [sendingToLAO, setSendingToLAO] = useState(false);
    const [loadingusersLAO, setLoadingusersLAO] = useState(false);
    const [selectedUserLAO, setselectedUserLAO] = useState('');

  const ROLES = {
    COLLECTOR: 1,
    LAO: 3,
    SAMANVAY: 6,
    PROJECT_INCHARGE: 18,
    DATA_ENTRY: 14,
    Tehsildar: 5,
  };


  const userData = JSON.parse(localStorage.getItem('userData'));
  const userRole = parseInt(userData?.data?.user_role || userData?.user_role, 10);

  const documentRef = useRef(null);

  // NEW STATES FOR SEND TO LAO MODAL
  const [showSendToLAOModal, setShowSendToLAOModal] = useState(false);
  const [laoUsers, setLaoUsers] = useState([]);
  const [selectedLao, setSelectedLao] = useState('');
  const [remarks, setRemarks] = useState('Approved');
  const [selectedDocument, setSelectedDocument] = useState(null);
    const [showProgress, setShowProgress] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [successMessage, setSuccessMessage] = useState('');
  const [showSuccess, setShowSuccess] = useState(false);
  const [loadingUsers, setLoadingUsers] = useState(false);
   const [usersLAO, setusersLAO] = useState([]);
 const { uploadStatus, uploadError, selectedSignDocument, resetSignatureState, signDocument } = useSignature();
  const [showSignaturePad, setShowSignaturePad] = useState(false);
  const [pdfForSigning, setPdfForSigning] = useState(null);
   const [selectedDocuments, setSelectedDocuments] = useState({});
    // Documents Viewer state
    const [showDocumentViewer, setShowDocumentViewer] = useState(false);
    const [fileUrlToView, setFileUrlToView] = useState('');
    const [isPDFToView, setIsPDFToView] = useState(false);
    const [isViewMode, setIsViewMode] = useState(false);

   const handleCloseLAOModal = () => {
    setShowSendToLAOModal(false);
    setselectedUserLAO('');
    setremarksLAO(''); // or 'Approved'
    setselectedDocumentLAO(null);
    resetSignatureState();
  };
   // Unified function to handle viewing documents (for both modals)
  const handleViewDocument = (urlOrFile) => {
    if (!urlOrFile) return;

    let url;
    let isPdf;

    if (urlOrFile instanceof File) {
      url = URL.createObjectURL(urlOrFile);
      isPdf = urlOrFile.type === 'application/pdf';
    } else { // Assuming it's a URL string from backend
      url = urlOrFile;
      isPdf = urlOrFile.toLowerCase().includes('.pdf');
    }

    setFileUrlToView(url);
    setIsPDFToView(isPdf);
    setShowDocumentViewer(true);
  };

  const closeDocumentViewer = () => {
    setShowDocumentViewer(false);
    // Revoke Object URL if it was created from a File object
    if (fileUrlToView.startsWith('blob:')) {
      URL.revokeObjectURL(fileUrlToView);
    }
    setFileUrlToView('');
    setIsPDFToView(false);
  };

  // Fetch projectId
  useEffect(() => {
    const getProjectInfo = () => {
      const currentProjectData = localStorage.getItem('currentProjectData');
      if (currentProjectData) {
        try {
          const projectData = JSON.parse(currentProjectData);
          return {
            id: projectData.project_id || projectData.id,
            name: projectData.project_name || projectData.name
          };
        } catch (e) {
          console.error('Error parsing current project data:', e);
        }
      }

      const selectedProject = localStorage.getItem('selectedProject');
      if (selectedProject) {
        try {
          const project = JSON.parse(selectedProject);
          return {
            id: project.project_id || project.id,
            name: project.project_name || project.name
          };
        } catch (e) {
          console.error('Error parsing selected project:', e);
        }
      }

      const userData = localStorage.getItem('userData');
      if (userData) {
        try {
          const user = JSON.parse(userData);
          const projectId = user.data?.project_id || user.project_id;
          const projectName = user.data?.project_name || user.project_name || 'Unknown Project';
          return {
            id: projectId,
            name: projectName
          };
        } catch (e) {
          console.error('Error parsing user data:', e);
        }
      }
      return { id: null, name: null };
    };

    const projectInfo = getProjectInfo();
    setProjectId(projectInfo.id);
  }, []);

  // Fetch proposalId
  useEffect(() => {
    const getProposalInfo = () => {
      const currentProposal = JSON.parse(localStorage.getItem('userData') || '{}');

      if (currentProposal) {
        try {
          return {
            proposalId: currentProposal?.data?.default_proposal ||
              currentProposal?.data?.proposal_id ||
              currentProposal?.default_proposal ||
              currentProposal?.proposal_id ||
              null
          }
        } catch (e) {
          console.error('Error parsing proposal data:', e);
        }
      }
      return { proposalId: null };
    };

    const proposalInfo = getProposalInfo();
    setProposalId(proposalInfo.proposalId);
  }, []);

  // Fetch dropdown options
  useEffect(() => {
    const fetchActionTypes = async () => {
      try {
        const response = await apiService.getLandReportActions();
        if (response.data && Array.isArray(response.data)) {
          const activeActions = response.data
            .filter(action => action.is_active)
            .map(action => ({
              id: action.action_id,
              type: action.action_type
            }));
          setRecordTypeOptions(activeActions);
        }
      } catch (error) {
        console.error('Error fetching action types:', error);
      }
    };

    fetchActionTypes();
  }, []);

  // Fetch records
  useEffect(() => {
    const fetchRecords = async () => {
      if (projectId && proposalId) {
        setLoadingRecords(true);
        try {
          await fetchProposalData();
          await fetchTehsildarRecords();
        } catch (err) {
          console.error('Error fetching records:', err);
        } finally {
          setLoadingRecords(false);
        }
      }
    };

    fetchRecords();
  }, [projectId, proposalId]);

  // Fetch LAO users
  useEffect(() => {
    if (projectId && proposalId && userRole === ROLES.Tehsildar) {
      fetchLaoUsers();
    }
  }, [projectId, proposalId]);

  const fetchLaoUsers = async () => {
    const role = 3;
    setLoadingUsers(true);
    try {
      const response = await apiService.getAllAssignUserRoleLAO(role, projectId, proposalId);
      if (response.status === 200 && response.data) {
        setLaoUsers(Array.isArray(response.data) ? response.data : []);
        if (response.data.length > 0) {
          setSelectedLao(response.data[0].usr_id || response.data[0].id);
          // setUsersLao(response.data[0].usr_id || response.data[0].id);
        }
      }
    } catch (error) {
      console.error('Error fetching LAO users:', error);
      setLaoUsers([]);
    } finally {
      setLoadingUsers(false);
    }
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const fetchTehsildarRecords = async () => {
    if (!projectId || !proposalId) return;

    try {
      setLoading(true);
      const result = await apiService.getTehsildarRecord(projectId, proposalId);

      if (result.status === 200 && result.data) {
        const mappedRecords = result.data.map((item, index) => {
          const uniqueId = item.report_id ?? `${item.owner_id ?? 'owner'}-${item.owner_survey_no || item.survey_no || 'survey'}-${index}`;
          return {
            id: uniqueId, 
            apiId: item.report_id ?? null,
            gatKramank: item.owner_survey_no || item.survey_no || '',
            recordType: item.action_type || '',
            actionId: item.action_id ?? '',
            ferfarKramank: item.modification_no || '',
            ferfarDinak: item.modification_date ? formatDate(item.modification_date) : '',
            ownerId: item.owner_id || item.land_owner_id || '',
            ownerName: item.owner_name || '',
            villageName: item.village_name || 'इतर', // Captured Village
            isEditing: false
          };
        });

        setRecords(mappedRecords);

        if (result.workSummary && Array.isArray(result.workSummary)) {
          setWorkSummary(result.workSummary);
        }
        if (result.report && Array.isArray(result.report)) {
          setReportData(result.report);
        }
      }
    } catch (error) {
      console.error('Error fetching Tehsildar records:', error);
    } finally {
      setLoading(false);
    }
  };

  const fetchProposalData = async () => {
    if (!projectId || !proposalId) return;

    try {
      const result = await apiService.getProposalPublish(projectId, proposalId);
      console.log('PROPOSAL DATA', result);
      
      if (result.status === 200 && result.data) {
        const item = result.data;
        setFormData(prev => ({
          ...prev,
          bhusampadan_no: item.section_11_bhusampadan_no || item.acquisition_proposal_no,
          village_name: item.village_name || prev.village_name,
          taluka: item.taluka_name || prev.taluka,
          district: item.dist_name || prev.district
        }));
      }
    } catch (error) {
      console.error('Error fetching proposal data:', error);
    }
  };

  const handleEdit = (id) => {
    setRecords(prev => {
      const rec = prev.find(r => r.id === id);
      if (rec) {
        setTempData(prevTemp => ({
          ...prevTemp,
          [id]: { ...rec }
        }));
      }
      return prev.map(r => r.id === id ? { ...r, isEditing: true } : r);
    });
  };

  const handleSave = async (id) => {
    const record = records.find(r => r.id === id);
    if (!projectId || !proposalId) {
      alert('प्रकल्प किंवा प्रस्ताव ID उपलब्ध नाही.');
      return;
    }

    try {
      setLoading(true);
      let modificationDate = '';
      if (record.ferfarDinak && record.ferfarDinak !== 'निरंक') {
        const parts = record.ferfarDinak.split('/');
        if (parts.length === 3) {
          modificationDate = `${parts[2]}-${parts[1]}-${parts[0]}`;
        }
      }

      const formDataObj = new FormData();
      formDataObj.append('project_id', projectId);
      formDataObj.append('proposal_id', proposalId);
      formDataObj.append('owner_id', record.ownerId || '');
      formDataObj.append('survey_no', record.gatKramank);
      formDataObj.append('action_id', record.actionId || tempData[id]?.actionId || recordTypeOptions[0]?.id || '');
      formDataObj.append('modification_no', record.ferfarKramank || '');
      formDataObj.append('modification_date', modificationDate);

      const result = await apiService.postAddUpdateTehsildarRecord(formDataObj);
      const isSuccess = !result || result.status === 200 || result.status === 201 || result.status === 'success' || result.success === true || result.data?.success === true || result.data?.status === 200 || result.data?.status === 201 || result.message?.includes('success') || result.data?.message?.includes('success');

      if (isSuccess) {
        alert('नोंद यशस्वीरित्या जतन झाली');
        setRecords(prev => prev.map(r => r.id === id ? { ...r, isEditing: false } : r));
        setTempData(prev => {
          const updated = { ...prev };
          delete updated[id];
          return updated;
        });
        await fetchTehsildarRecords();
      } else {
        alert('नोंद जतन करण्यात अयशस्वी.');
      }
    } catch (err) {
      alert('नोंद जतन करताना त्रुटी.');
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = (id) => {
    const originalData = tempData[id];
    if (originalData) {
      setRecords(prev => prev.map(r => r.id === id ? { ...r, ...originalData, isEditing: false } : r));
    } else {
      setRecords(prev => prev.map(r => r.id === id ? { ...r, isEditing: false } : r));
    }
    setTempData(prev => {
      const updated = { ...prev };
      delete updated[id];
      return updated;
    });
  };

  const handleRecordTypeChange = (id, actionId) => {
    const selectedAction = recordTypeOptions.find(opt => opt.id === parseInt(actionId));
    setRecords(records.map(record =>
      record.id === id ? { ...record, actionId: parseInt(actionId), recordType: selectedAction ? selectedAction.type : '' } : record
    ));
  };

  const handleFerfarKramankChange = (id, value) => {
    setRecords(records.map(record => record.id === id ? { ...record, ferfarKramank: value } : record));
  };

  const handleFerfarDinakChange = (id, value) => {
    setRecords(records.map(record => record.id === id ? { ...record, ferfarDinak: value } : record));
  };

  const handlePrint = () => {
    const printContent = documentRef.current?.innerHTML;
    if (!printContent) {
      alert("प्रिंट करण्यासाठी सामग्री उपलब्ध नाही.");
      return;
    }

    const win = window.open("", "", "height=900,width=1200");
    win.document.write(`
      <html>
        <head>
          <title>अहवाल - भूसंपादन प्रकरण</title>
          <style>
            @page {
              size: A4 portrait;   
              margin-top: 0.25in;
              margin-bottom: 0.25in;
              margin-left: 0.5in;
              margin-right: 0.5in;
            }
            
            body {
              font-family: 'DVOT-Surekh', 'Mangal', 'Arial', sans-serif;
              font-size: 14px;
              line-height: 1.4;
            }

            .document-container {
              max-width: 100%;
              margin: 0 auto;
            }

            .header-section {
              text-align: center;
              margin-bottom: 20px;
            }

            .header-title {
              font-size: 22px;
              font-weight: bold;
              margin-bottom: 10px;
              text-decoration: underline;
            }

            .info-line {
              margin: 5px 0;
              font-size: 15px;
            }

            table {
              width: 100%;
              border-collapse: collapse;
              margin: 20px 0;
            }

            th, td {
              border: 1px solid black;
              padding: 8px;
              text-align: center;
            }

            th {
              background-color: #f3f4f6;
              font-weight: bold;
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
            }

            .font-bold { font-weight: bold; }

            .signature-section {
              display: flex;
              justify-content: space-between; 
              margin-top: 50px;
              padding: 0 20px;
            }

            .signature-box {
              text-align: center;
              flex: 1;
            }

            .page-break {
              page-break-after: always;
            }

            .page-two-header {
              text-align: center;
              font-weight: bold;
              margin-bottom: 20px;
            }

            .page-two-title {
              font-size: 16px;
              margin-bottom: 5px;
            }

            .page-two-subtitle {
              font-size: 12px;
              margin-bottom: 15px;
              font-weight: normal;
            }

            @media print {
              body { margin: 0; }
              .no-print { display: none; }
            }
          </style>
        </head>
        <body>
          ${printContent}
        </body>
      </html>
    `);

    win.document.close();
    win.print();
  };

  const handleSendToLAO = async () => {
    if (!selectedDocument || !selectedLao) {
      alert('कृपया LAO आणि दस्तऐवज निवडा');
      return;
    }
    setSendingToLAO(true);
    setShowProgress(true);
    setUploadProgress(0);

    try {
      const formDataObj = new FormData();
      formDataObj.append('project_id', projectId);
      formDataObj.append('proposal_id', proposalId);
      formDataObj.append('remarks', remarks);
      formDataObj.append('usr_id', selectedLao);
      formDataObj.append('document', selectedDocument);

      const response = await apiService.postTrackingLAO(formDataObj);
      if (response.status === 200) {
        setUploadProgress(100);
        await new Promise(resolve => setTimeout(resolve, 500));
        setSuccessMessage('यशस्वीरित्या LAO ला पाठवले!');
        setShowSuccess(true);
        setTimeout(() => setShowSuccess(false), 3000);
        setShowSendToLAOModal(false);
        setSelectedLao('');
        setRemarks('Approved');
        setSelectedDocument(null);
      } else {
        setUploadProgress(0); 
      }

    } catch (error) {
      alert('LAO ला पाठवताना त्रुटी.');
    } finally {
      setSendingToLAO(false);
      setShowProgress(false);
      setUploadProgress(0);
    }
  };

  // Group records by village
  const groupedRecords = records.reduce((acc, record) => {
    const village = record.villageName || 'इतर';
    if (!acc[village]) {
      acc[village] = [];
    }
    acc[village].push(record);
    return acc;
  }, {});

  const totalGat = workSummary.reduce((sum, item) => sum + item.total_count, 0);
  const completedGat = workSummary.reduce((sum, item) => sum + item.completed, 0);
  const remainingGat = workSummary.reduce((sum, item) => sum + item.remaining, 0);

  if (loadingRecords) {
    return (
      <div className="p-6 max-w-7xl mx-auto flex justify-center items-center h-80">
        <Loader2 className="h-10 w-10 text-purple-600 animate-spin" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-7xl mx-auto bg-white shadow-lg rounded-lg p-8">
        {/* Header with Action Buttons */}
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-2xl font-bold">भूमि अभिलेख अद्यावतीकरण</h1>
          <div className="flex gap-3">
            <button
              onClick={handlePrint}
              className="flex items-center gap-2 bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700 transition-colors"
            >
              <Printer size={20} />
              प्रिंट करा
            </button>
            {userRole === ROLES.Tehsildar && (
              <button
                onClick={() => {setShowSendToLAOModal(true);
                  console.log("button Clicked");}
                  
                }
                className="flex items-center gap-2 bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition-colors"
              >
                <Send size={20} />
                LAO ला पाठवा
              </button>
            )}
          </div>
        </div>

        {/* UI Table: Grouped By Village */}
        <div className="mb-8">
          {Object.keys(groupedRecords).length === 0 ? (
            <table className="w-full border-2 border-black">
              <thead>
                <tr className="bg-gray-100">
                  <th className="border-2 border-black p-3 text-center">अ.क्र</th>
                  <th className="border-2 border-black p-3 text-center">कलम 11(1) खालील अधिसूचनेतील गट क्रमांक</th>
                  <th className="border-2 border-black p-3 text-center">नोंदीचा प्रकार</th>
                  <th className="border-2 border-black p-3 text-center">फेरफार क्रमांक</th>
                  <th className="border-2 border-black p-3 text-center">फेरफार दिनांक</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td colSpan="5" className="border-2 border-black p-4 text-center text-gray-500">
                    कोणतीही नोंद उपलब्ध नाही
                  </td>
                </tr>
              </tbody>
            </table>
          ) : (
            Object.entries(groupedRecords).map(([village, villageRecords]) => (
              <div key={village} className="mb-8">
                <h3 className="text-xl font-bold mb-2 text-gray-800 border-l-4 border-blue-500 pl-2">गाव: {village}</h3>
                <div className="overflow-x-auto">
                  <table className="w-full border-2 border-black">
                    <thead>
                      <tr className="bg-gray-100">
                        {(userRole === ROLES.LAO || userRole === ROLES.DATA_ENTRY || userRole === ROLES.Tehsildar) && (
                          <th className="border-2 border-black p-3 text-center">कृती</th>
                        )}
                        <th className="border-2 border-black p-3 text-center">अ.क्र</th>
                        <th className="border-2 border-black p-3 text-center">गट क्रमांक</th>
                        <th className="border-2 border-black p-3 text-center">अद्यावत केलेल्या नोंदीचा प्रकार</th>
                        <th className="border-2 border-black p-3 text-center">फेरफार क्रमांक</th>
                        <th className="border-2 border-black p-3 text-center">फेरफार दिनांक</th>
                      </tr>
                    </thead>
                    <tbody>
                      {villageRecords.map((record, index) => (
                        <tr key={record.id}>
                          {(userRole === ROLES.LAO || userRole === ROLES.DATA_ENTRY || userRole === ROLES.Tehsildar) && (
                            <td className="border-2 border-black p-2">
                              <div className="flex gap-2 justify-center">
                                {record.isEditing ? (
                                  <>
                                    <button onClick={() => handleSave(record.id)} className="bg-green-600 text-white px-2 py-1 rounded">
                                      <Save size={16} />
                                    </button>
                                    <button onClick={() => handleCancel(record.id)} className="bg-gray-600 text-white px-2 py-1 rounded">
                                      <X size={16} />
                                    </button>
                                  </>
                                ) : (
                                  <button onClick={() => handleEdit(record.id)} className="bg-blue-600 text-white px-2 py-1 rounded">
                                    <Edit2 size={16} />
                                  </button>
                                )}
                              </div>
                            </td>
                          )}
                          <td className="border-2 border-black p-3 text-center font-semibold">{index + 1}</td>
                          <td className="border-2 border-black p-2 text-center">{record.gatKramank}</td>
                          <td className="border-2 border-black p-2">
                            {record.isEditing ? (
                              <select
                                value={record.actionId || ""}
                                onChange={(e) => handleRecordTypeChange(record.id, e.target.value)}
                                className="w-full p-2 border border-gray-300 rounded"
                              >
                                {recordTypeOptions.map((opt) => (
                                  <option key={opt.id} value={opt.id}>{opt.type}</option>
                                ))}
                              </select>
                            ) : (
                              record.recordType
                            )}
                          </td>
                          <td className="border-2 border-black p-2 text-center">
                            {record.isEditing ? (
                              <input type="text" value={record.ferfarKramank} onChange={(e) => handleFerfarKramankChange(record.id, e.target.value)} className="w-full p-2 border rounded" />
                            ) : (
                              record.ferfarKramank
                            )}
                          </td>
                          <td className="border-2 border-black p-2 text-center">
                            {record.isEditing ? (
                              <input 
                                type="date" 
                                value={record.ferfarDinak === 'निरंक' ? '' : record.ferfarDinak.split('/').reverse().join('-')} 
                                onChange={(e) => {
                                  const val = e.target.value;
                                  handleFerfarDinakChange(record.id, val ? val.split('-').reverse().join('/') : '');
                                }} 
                                className="w-full p-2 border rounded" 
                              />
                            ) : (
                              record.ferfarDinak
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            ))
          )}
        </div>

        {/* Work Details Section */}
        <h2 className="text-xl font-bold text-center mb-6 mt-8">कामाचा तपशिल</h2>
        <table className="w-full border-2 border-black">
          <thead>
            <tr className="bg-gray-100">
              <th className="border-2 border-black p-3 text-center">एकूण गट क्रमांक</th>
              <th className="border-2 border-black p-3 text-center">अद्यावतीकरण झालेले गट</th>
              <th className="border-2 border-black p-3 text-center">प्रलंबित असलेले गट</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="border-2 border-black p-3 text-center text-lg font-semibold">{totalGat}</td>
              <td className="border-2 border-black p-3 text-center text-lg font-semibold">{completedGat}</td>
              <td className="border-2 border-black p-3 text-center text-lg font-semibold">{remainingGat}</td>
            </tr>
          </tbody>
        </table>

        {/* Hidden Print Content */}
        <div style={{ display: 'none' }}>
          <div ref={documentRef} className="document-container">
            
            {/* 1. PRINT TABLES - Separate page per village */}
            {Object.keys(groupedRecords).length === 0 ? (
              <div>
                <div className="header-section">
                  <div className="header-title">अहवाल</div>
                  <div className="info-line"><strong>भूसंपादन प्रकरण क्रमांक :-</strong> {formData.bhusampadan_no || ''}</div>
                </div>
                <table>
                  <tr><td>कोणतीही नोंद उपलब्ध नाही</td></tr>
                </table>
              </div>
            ) : (
              Object.entries(groupedRecords).map(([village, villageRecords], idx) => (
                <div key={`print-${village}`} className="page-break">
                  {/* Separate Header for each village */}
                  <div className="header-section">
                    <div className="header-title">भूमि अभिलेख अद्यावतीकरण अहवाल</div>
                    <div className="info-line">
                      <strong>भूसंपादन प्रकरण क्रमांक :-</strong> {formData.bhusampadan_no || ''}
                    </div>
                    <div className="info-line" style={{ display: 'flex', justifyContent: 'space-between', padding: '0 20px', marginTop: '10px' }}>
                      <span><strong>गावाचे नाव :-</strong> {village}</span>
                      <span><strong>तालुका :-</strong> {formData.taluka || ''}</span>
                      <span><strong>जिल्हा :-</strong> {formData.district}</span>
                    </div>
                  </div>

                  <table>
                    <thead>
                      <tr>
                        <th style={{ width: '50px' }}>अ.क्र</th>
                        <th style={{ width: '120px' }}>कलम 11(1) खालील अधिसूचनेतील गट क्रमांक</th>
                        <th>नियम 2014 चे नियम 10(3) नुसार अद्यावत करण्यात आलेल्या नोंदीचा प्रकार</th>
                        <th style={{ width: '100px' }}>गाव नमुना 6 मधील फेरफार क्रमांक</th>
                        <th style={{ width: '100px' }}>गाव नमुना 6 मधील फेरफार दिनांक</th>
                      </tr>
                    </thead>
                    <tbody>
                      {villageRecords.map((record, index) => (
                        <tr key={record.id}>
                          <td>{index + 1}</td>
                          <td>{record.gatKramank}</td>
                          <td style={{ textAlign: 'left', padding: '8px' }}>{record.recordType}</td>
                          <td>{record.ferfarKramank}</td>
                          <td>{record.ferfarDinak}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>

                  {/* Signatures at the end of each village record */}
                  <div className="signature-section">
                    <div className="signature-box"><div className="font-bold">ग्राम महसूल अधिकारी</div><br/><br/>(स्वाक्षरी)</div>
                    <div className="signature-box"><div className="font-bold">मंडळ अधिकारी</div><br/><br/>(स्वाक्षरी)</div>
                    <div className="signature-box"><div className="font-bold">तहसीलदार</div><br/><br/>(स्वाक्षरी / शिक्का)</div>
                  </div>
                </div>
              ))
            )}

            {/* 2. PRINT - Page Two (Summary & Action Report) */}
            <div className="page-two">
              <div className="page-two-header">
                <div className="page-two-title">संपादनाखालील जमिनीचे भूमि अभिलेख अद्यावतीकरण कार्यपुर्ती अनुपालन अहवाल</div>
                <div className="page-two-subtitle">(पहा-भूमिसंपादन, पुनर्वसन व पुनर्स्थापना करतांना वाजवी भरपाई मिळण्याचा व पारपर्शकतेचा हक्क (महाराष्ट्र) नियम 2014 मधील नियम 10(3))</div>
                
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px', margin: '20px 0', padding: '0 20px' }}>
                  <span><strong>भूसंपादन प्रकरण क्र. :-</strong> {formData.bhusampadan_no || ''}</span>
                  <span><strong>तालुका :-</strong> {formData.taluka || ''}</span>
                  <span><strong>जिल्हा :-</strong> {formData.district}</span>
                </div>
              </div>

              <h3 style={{ fontSize: '14px', marginBottom: '10px' }}>अ) कामाचा तपशिल:</h3>
              <table style={{ marginBottom: '30px' }}>
                <thead>
                  <tr>
                    <th>एकूण गट क्रमांक</th>
                    <th>अद्यावतीकरण झालेले गट क्रमांक</th>
                    <th>अद्यावतीकरण प्रलंबित असलेले गट क्रमांक</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{totalGat}</td>
                    <td>{completedGat}</td>
                    <td>{remainingGat}</td>
                  </tr>
                </tbody>
              </table>

              <h3 style={{ fontSize: '14px', marginBottom: '10px' }}>ब) केलेल्या कार्यवाहीचा तपशिल:</h3>
              <table>
                <thead>
                  <tr>
                    <th style={{ width: '60px' }}>अ.क्र</th>
                    <th>पूर्ण केलेल्या कार्याबाबत तपशिल</th>
                    <th style={{ width: '120px' }}>गट क्रमांक</th>
                    <th style={{ width: '120px' }}>नोंदीची संख्या</th>
                  </tr>
                </thead>
                <tbody>
                  {reportData.map((item, index) => (
                    <tr key={index}>
                      <td>{item.action_id}</td>
                      <td style={{ textAlign: 'left', paddingLeft: '10px' }}>{item.action_type}</td>
                      <td>{item.survey_no}</td>
                      <td>{item.count}</td>
                    </tr>
                  ))}
                  {/* Fill empty rows to maintain layout if less than 15 rows */}
                  {[...Array(Math.max(0, 15 - reportData.length))].map((_, idx) => (
                    <tr key={`empty-${idx}`}>
                      <td style={{ color: 'transparent' }}>-</td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <div className="signature-section" style={{ marginTop: '80px' }}>
                <div className="signature-box"><div className="font-bold">ग्राम महसूल अधिकारी</div><br/><br/>(स्वाक्षरी)</div>
                <div className="signature-box"><div className="font-bold">मंडळ अधिकारी</div><br/><br/>(स्वाक्षरी)</div>
                <div className="signature-box"><div className="font-bold">तहसीलदार</div><br/><br/>(स्वाक्षरी / शिक्का)</div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
   
      
}

export default Tehsildar;